// extracted by mini-css-extract-plugin
module.exports = {"error-base":"Error_error-base__a2Lpr","plain":"Error_plain__3_uaI","card":"Error_card__1goTL","row":"Error_row__1EXms","col":"Error_col__fT4An"};